/**
 * R10-12 — destaque "Ao vivo": regras puras (sem React) do selo do menu e da faixa do topo.
 * A lista vem de `GET /live_sessions/live_now`: aulas visiveis ao usuario com a janela de
 * entrada aberta agora, ja ao vivo primeiro.
 */
import type { LiveNowSession } from '@/types/api'
import { formatSessionTime } from '@/features/liveSessions/liveSessionsFormat'

/** Intervalo da consulta: barato (uma consulta indexada) e suficiente para "entrou, viu". */
export const LIVE_NOW_POLL_MS = 60_000
const DISMISS_KEY_PREFIX = 'medhunter-live-now-dismissed:'

export function hasLiveNow(sessions: readonly LiveNowSession[] | undefined): boolean {
  return (sessions?.length ?? 0) > 0
}

/** Para o menu do instrutor: so as aulas que ele conduz (host ou panelista). */
export function conductedSessions(sessions: readonly LiveNowSession[] | undefined): LiveNowSession[] {
  return (sessions ?? []).filter((session) => session.conducting)
}

/** "Aula ao vivo agora: X" ou, antes do inicio, "Aula ao vivo às 20:00: X" (fuso da aula). */
export function liveNowBannerText(session: LiveNowSession, now: Date): string {
  const started = session.status === 'live' || now.getTime() >= new Date(session.starts_at).getTime()
  if (started) return `Reunião ao vivo agora: ${session.title}`

  return `Reunião ao vivo às ${formatSessionTime(session.starts_at, session.timezone)}: ${session.title}`
}

/** Fechar a faixa vale por aula: outra aula no mesmo dia volta a aparecer. */
export function liveNowDismissKey(sessionId: number): string {
  return `${DISMISS_KEY_PREFIX}${sessionId}`
}
